import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Button, Typography, Snackbar, Alert, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ControlPoint, West } from "@mui/icons-material";
import { useFetchReports } from "../../react-query/hooks/useFetchReport";
import NoReport from "../../assets/images/no_reports.png";
import NotesTableComponent from "./common/NotesTableComponent";
import DashboardHeaderSection from "../common/dashboardheader/DashboardHeader";
import Swal from "sweetalert2";

export const Notes = () => {
  const [notes, setNotes] = useState([
    {
      name: "Email Test",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
  ]);
  const [openAlert, setOpenAlert] = useState(false);
  const handleAlertClose = () => setOpenAlert(false);
  const { isError, data, isLoading, isFetched } = useFetchReports();
  const navigate = useNavigate();

  // const handleChange = (e) => {
  //     let { name, value } = e.target;
  //     setParams((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //     }));
  // };

  // const handleSubmit = async () => {
  // };

  const Init = async () => {};

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    // setNotes(data?.data);
  }, [isLoading]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleAlertClose}
      >
        <Alert
          onClose={handleAlertClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Note Created Successfully!
        </Alert>
      </Snackbar>
      <DashboardHeaderSection />
      <Box
        width={{ xs: "100%", lg: `calc(100% - 80px)` }}
        marginLeft={{ xs: "0px", lg: `80px` }}
        marginTop={8}
        padding={1}
        sx={{ height: "100vh", bgcolor: "#F0F2F5" }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-center" }}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="subtitle2" fontWeight={"bold"}>
              Notes
            </Typography>
          </Box>
        </Box>
        <Box>
          {isLoading ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </>
          ) : notes && notes.length > 0 ? (
            <NotesTableComponent
              loading={isLoading}
              notes={notes ? notes : []}
            />
          ) : (
            <Box sx={{ textAlign: "center" }}>
              <img src={NoReport} height={300} />
              <Typography color={"red"} variant="h6">
                No Data Found
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Notes;
